module.exports = __webpack_public_path__ + "media/04.f6e73c9b.mp3";